export const removeNonAlphanumeric = (input) => {
  return String(input).replace(/[^a-zA-Z0-9\s]/g, '');
};
